import React from 'react';
import { Box, Flex, Text, Button, Spacer, useColorModeValue } from '@chakra-ui/react';
import { FaCompactDisc, FaYoutube, FaHome } from 'react-icons/fa'; // Icons for navigation

const Navbar = ({ artistName, scrollToSection }) => {
  // Use Chakra's useColorModeValue to adapt colors to light/dark mode if implemented,
  // but here fixed to dark brand colors for consistency with theme config.
  const bgColor = useColorModeValue('brand.800', 'brand.800');
  const textColor = useColorModeValue('brand.300', 'brand.300');

  return (
    <Box
      bg={bgColor}
      px={4}
      py={3}
      shadow="md"
      position="sticky" // Makes navbar stick to the top
      top="0"
      zIndex="sticky" // Ensures it stays on top of other content
      borderRadius="xl" // Rounded corners for the navbar itself
      mx={{ base: 2, md: 4, lg: 8 }} // Margin on left/right for separation from edges
      mt={{ base: 2, md: 4, lg: 6 }} // Margin on top
    >
      <Flex h={16} alignItems="center" justifyContent="space-between" wrap="wrap">
        {/* Artist Name/Logo Area - click to scroll home */}
        <Box onClick={() => scrollToSection('home')} cursor="pointer" flexShrink={0}>
          <Text
            fontSize={{ base: "xl", md: "2xl" }}
            fontWeight="bold"
            color={textColor}
            transition="color 0.2s"
            _hover={{ color: 'brand.accent' }}
          >
            {artistName}
          </Text>
        </Box>

        <Spacer /> {/* Pushes navigation links to the right */}

        {/* Navigation Links */}
        <Flex alignItems="center" gap={{ base: 2, md: 4 }} wrap="wrap" justifyContent="center">
          <Button
            variant="ghost"
            color={textColor}
            leftIcon={<FaHome />}
            onClick={() => scrollToSection('home')}
            size={{ base: "sm", md: "md" }}
          >
            Home
          </Button>
          <Button
            variant="ghost"
            color={textColor}
            leftIcon={<FaCompactDisc />}
            onClick={() => scrollToSection('music')}
            size={{ base: "sm", md: "md" }}
          >
            Music
          </Button>
          <Button
            variant="ghost"
            color={textColor}
            leftIcon={<FaYoutube />}
            onClick={() => scrollToSection('videos')}
            size={{ base: "sm", md: "md" }}
          >
            Videos
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Navbar;